export default __webpack_public_path__ + "static/media/19.813293f3.jpg";